import { type VariantProps, cva } from "class-variance-authority";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cn } from "../lib/utils";

const labelVariants = cva(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
  {
    variants: {
      error: {
        true: "text-destructive",
      },
    },
    defaultVariants: {
      error: false,
    },
  },
);

type LabelProps = React.ComponentProps<typeof LabelPrimitive.Root> &
  VariantProps<typeof labelVariants>;

function Label({ className, error, ref, ...props }: LabelProps) {
  return (
    <LabelPrimitive.Root
      ref={ref}
      className={cn(labelVariants({ error, className }))}
      {...props}
    />
  );
}

export { Label, labelVariants };
